import { useWizardStore } from '../store/wizardStore';
import { StepShell } from '../components/StepShell';

export function Step0_VariantSelect() {
  const setVariant = useWizardStore((s) => s.setVariant);
  const goTo = useWizardStore((s) => s.goTo);

  const choose = (v: 'variant1' | 'variant2' | 'variant3'): void => {
    setVariant(v);
    goTo('yellow');
  };

  return (
    <StepShell title="Выбор варианта" subtitle="Выберите, какой пакет документов оформляется" current="variant">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
        <button
          onClick={() => choose('variant1')}
          className="bg-white hover:bg-slate-50 border-2 border-slate-300 rounded-2xl p-8 text-left shadow-sm active:scale-[0.99] transition"
        >
          <div className="text-2xl font-bold mb-2">Вариант 1</div>
          <div className="text-slate-700 mb-3">Окна — объединённый пакет</div>
          <ul className="text-sm text-slate-600 space-y-1">
            <li>— Договор купли-продажи (ООО «Ворота-Окна»)</li>
            <li className="text-slate-400">Один документ: продажа и монтаж</li>
          </ul>
        </button>

        <button
          onClick={() => choose('variant2')}
          className="bg-white hover:bg-slate-50 border-2 border-slate-300 rounded-2xl p-8 text-left shadow-sm active:scale-[0.99] transition"
        >
          <div className="text-2xl font-bold mb-2">Вариант 2</div>
          <div className="text-slate-700 mb-3">Окна — раздельный пакет</div>
          <ul className="text-sm text-slate-600 space-y-1">
            <li>— Договор купли-продажи (ООО «Ворота-Окна»)</li>
            <li>— Договор подряда (ИП Федина Е.И.)</li>
          </ul>
        </button>

        <button
          onClick={() => choose('variant3')}
          className="bg-white hover:bg-slate-50 border-2 border-slate-300 rounded-2xl p-8 text-left shadow-sm active:scale-[0.99] transition"
        >
          <div className="text-2xl font-bold mb-2">Вариант 3</div>
          <div className="text-slate-700 mb-3">Ворота</div>
          <ul className="text-sm text-slate-600 space-y-1">
            <li>— Договор купли-продажи ворот (ИП Шалеев А.Г.)</li>
            <li className="text-slate-400">Выбор схемы оплаты: 50/50 или 50/40/10</li>
          </ul>
        </button>
      </div>
    </StepShell>
  );
}
